import { Typography, useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { Container, Divider, Info } from './styles';
import VideoPresentation from '../../../components/VideoPresentation';
import ThumbPresentation from '../../../img/thumb/apresentacao.jpg';

export default function VideoSession() {
  const { t } = useTranslation();
  const isXs = useMediaQuery(theme => theme.breakpoints.down('xs'));

  return (
    <Container>
      <Info>
        <header>
          <Typography variant="h1" compnent="span">
            {t(
              'A primeira e única Rede de Depilação a Laser do Brasil sem distinção de gênero',
            )}
          </Typography>
        </header>
        <Divider />
        <div>
          <Typography component="p">
            {t(
              'Na Vialaser, você não precisa ter uma pele feminina, ou uma pele masculina, basta ter uma pele!',
            )}
          </Typography>
          <Typography component="p">
            {t(
              'Todos nossos pacotes, combos e promoções possuem valores iguais para todos os gêneros',
            )}
          </Typography>
        </div>
      </Info>
      <VideoPresentation
        title="Video de apresentação"
        width={isXs ? 300 : 425}
        height={isXs ? 169 : 240}
        src="https://vialaser.s3-sa-east-1.amazonaws.com/videos/VIALASER_VIDEOMANIFESTO_v2.mp4"
        thumbnail={ThumbPresentation}
      />
    </Container>
  );
}
